import {
  SHOW_IMAGE_OPTIONS_MODAL,
  SHOW_MOBILE_ERROR_MODAL,
  SHOW_INVITATION_MODAL,
  SHOW_PROGRESS_MODAL,
  SHOW_PROFILE_MODAL,
  SHOW_MODAL,
  SET_IMAGE_DATA,
  SET_IMAGE_DATA_LOADER,
  SET_IMAGE_LABELS,
  SET_IMAGE_ISSUES,
  SET_SELECTED_LABELS,
  SET_SELECTED_ISSUES,
  SET_SELECTED_CAROUSEL_INDEX,
  SET_IMAGE_TAGS,
  IS_IMAGE_TAG_LOADING,
  SHOW_LEARN_MORE_MODAL,
  SHOW_DATASET_ERROR_MODAL,
  SHOW_INTERNAL_ERROR_MODAL,
  SET_IMAGE_UNIQUENESS_DATA,
  SHOW_BUG_REPORT_MODAL,
  SET_IMAGE_LINKS,
  SET_SHOW_DS_CREATION_WARNING,
} from "./constants";

const INITIAL_STATE = {
  showImageOptionsModal: false,
  showDSCreationWarning: false,
  showMobileErrorModal: false,
  showInvitationModal: false,
  showProgressModal: false,
  showProfileModal: false,
  showModal: false,

  showDatasetErrorModal: null,

  imageData: null,
  imageDataLoader: false,
  imageLinks: [],
  imageLabels: [],
  imageIssues: [],
  selectedLabels: [],
  selectedIssues: [],
  selectedCarouselIndex: 0,

  imageTags: [],
  isImageTagLoading: false,

  showLearnMoreModal: false,

  showInternalErrorModal: false,
  imageUniquenessData: [],
  showBugReportModal: false,
};
const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SHOW_MOBILE_ERROR_MODAL:
      return { ...state, showMobileErrorModal: action.data };

    case SHOW_INVITATION_MODAL:
      return { ...state, showInvitationModal: action.data };

    case SHOW_PROFILE_MODAL:
      return { ...state, showProfileModal: action.data };

    case SHOW_IMAGE_OPTIONS_MODAL:
      return { ...state, showImageOptionsModal: action.data };

    case SHOW_PROGRESS_MODAL:
      return { ...state, showProgressModal: action.data };

    case SHOW_MODAL:
      return { ...state, showModal: action.data };

    case SET_IMAGE_DATA:
      return { ...state, imageData: action.data };

    case SET_IMAGE_DATA_LOADER:
      return { ...state, imageDataLoader: action.data };

    case SET_IMAGE_ISSUES:
      return { ...state, imageIssues: action.data };

    case SET_SELECTED_ISSUES:
      return { ...state, selectedIssues: action.data };

    case SET_IMAGE_LABELS:
      return { ...state, imageLabels: action.data };

    case SET_SELECTED_LABELS:
      return { ...state, selectedLabels: action.data };

    case SET_SELECTED_CAROUSEL_INDEX:
      return { ...state, selectedCarouselIndex: action.data };

    case SET_IMAGE_TAGS:
      return { ...state, imageTags: action.data };
    case IS_IMAGE_TAG_LOADING:
      return { ...state, isImageTagLoading: action.data };

    case SHOW_LEARN_MORE_MODAL:
      return { ...state, showLearnMoreModal: action.data };

    case SHOW_DATASET_ERROR_MODAL:
      return { ...state, showDatasetErrorModal: action.data };

    case SHOW_INTERNAL_ERROR_MODAL:
      return { ...state, showInternalErrorModal: action.data };

    case SET_IMAGE_UNIQUENESS_DATA:
      return { ...state, imageUniquenessData: action.data };

    case SHOW_BUG_REPORT_MODAL:
      return { ...state, showBugReportModal: action.data.flag };

    case SET_IMAGE_LINKS:
      return { ...state, imageLinks: action.data };

    case SET_SHOW_DS_CREATION_WARNING:
      return { ...state, showDSCreationWarning: action.data };

    default:
      return state;
  }
};

export default reducer;
